export default __webpack_public_path__ + "static/media/MarketRealCase1.826a148b.png";